import {gql} from '@apollo/client';

export const CHECK_SUBMITTED_REQUESTS = gql`
    query CheckSubmittedRequests($clientGuid: String, $authorizationGuid: String, $requestTypes: [RequestType]) {
        openCaseSubmitRequestQuery(
            clientGuid: $clientGuid
            authorizationGuid: $authorizationGuid
            requestTypes: $requestTypes
        ) {
            guid, authorizationGuid, caseNumber, clientGuid,
            reason, recordType, requestType, status
        }
    }
`;

export type CheckSubmittedRequestsResponse = {
    openCaseSubmitRequestQuery: Array<{
        status: string;
        caseNumber: string;
        recordType: string;
        requestType: string;
        reason: string;
    }>;
};

export function submittedRequestValidationMessage(newRequestType: String, requestType: String, caseNumber: String) {
    const requestInfo = caseNumber
        ? `'${requestType}' Request ${caseNumber}`
        : `'${requestType}'`;

    return `${requestInfo} has been submitted and is in review.
            A ${newRequestType} request can't be submitted at this time. 
            Please wait until the previously submitted request is resolved before submitting a new one. If you need more information on the status of this request, please reach out to supportservices@catalight.org`;

}
